import { render } from "./App.vue?vue&type=template&id=de897f04"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=de897f04&lang=stylus"
script.render = render

export default script